import React, { useEffect, useLayoutEffect, useState } from 'react';
import { ErrorState } from './error-state.component';

type MenuNextGlobal = {
  render: (renderProps: unknown) => void;
  setNavigationData: (data: unknown) => void;
};

type MenuNextProps = {
  navigationData?: unknown;
};

export const MenuNext = ({ navigationData }: MenuNextProps) => {
  const [isScriptLoaded, setIsScriptLoaded] = useState(false);
  const [isError, setIsError] = useState(false);

  useLayoutEffect(() => {
    const script = document.createElement('script');
    script.type = 'module';

    const hostname = window.location.hostname;

    let cdnUrl = 'https://hcm.cdn.elmotalent.com.au';

    if (hostname.endsWith('elmodev.com')) {
      cdnUrl = 'https://hcm.cdn.elmodev.com';
    }

    if (hostname.endsWith('elmotalent.co.nz')) {
      cdnUrl = 'https://hcm.cdn.elmotalent.co.nz';
    }

    if (hostname.endsWith('elmogov.com.au')) {
      cdnUrl = 'https://hcm-cdn.elmogov.com.au';
    }

    script.src = `${cdnUrl}/menu-next/main.js`;
    script.crossOrigin = 'anonymous';

    script.onload = () => {
      // @ts-expect-error MenuNext is expected to be globally available after script load
      const MenuNext = window.MenuNext as MenuNextGlobal;

      if (MenuNext) {
        MenuNext.render({
          rootElement: document.getElementById('elmo-navigation-menu'),
          autoFetchNavigationData: false,
        });
      } else {
        setIsError(true);
      }

      setIsScriptLoaded(true);
    };

    script.addEventListener('error', () => setIsError(true));

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  useEffect(() => {
    if (isScriptLoaded && navigationData) {
      // @ts-expect-error MenuNext is expected to be globally available after script load
      const MenuNext = window.MenuNext as MenuNextGlobal;

      if (MenuNext) {
        MenuNext.setNavigationData(navigationData);
      } else {
        setIsError(true);
      }
    }
  }, [isScriptLoaded, navigationData]);

  return isError ? <ErrorState /> : <div id="elmo-navigation-menu" />;
};
